import { BadgeStyled } from '@procurify/ui'
import styled from 'styled-components'

export const TabStyled = styled.a`
  font-size: ${(props) =>
    props.theme.typography.pxToRem(props.theme.fontSizes.button)};
  font-weight: ${(props) => props.theme.fontWeights.semibold};

  display: inline-flex;
  gap: ${(props) => props.theme.space.small};
  align-items: center;
  justify-content: center;

  min-width: ${(props) => props.theme.typography.pxToRem(80)};
  text-align: center;

  padding: ${(props) => props.theme.typography.pxToRem(20)}
    ${(props) => props.theme.typography.pxToRem(16)};
  cursor: pointer;
  position: relative;

  && {
    color: ${(props) => props.theme.colors.tabs.contentInactive};

    ${BadgeStyled} {
      background-color: ${(props) => props.theme.colors.tabs.contentInactive};
    }

    &:hover {
      color: ${(props) => props.theme.colors.tabs.contentInactive};
    }
  }

  &:after {
    content: '';
    display: block;
    position: absolute;
    bottom: 0;
    right: 0;
    left: 0;
    height: ${(props) => props.theme.typography.pxToRem(4)};
    border-radius: 2px 2px 0 0;
    background-color: transparent;
  }

  &:hover {
    color: ${(props) => props.theme.colors.tabs.contentInactive};

    &:after {
      background-color: ${(props) => props.theme.colors.tabs.divider};
    }
  }

  &.active {
    color: ${(props) => props.theme.colors.tabs.contentActive};

    ${BadgeStyled} {
      background-color: ${(props) => props.theme.colors.tabs.contentActive};
    }

    &:hover {
      color: ${(props) => props.theme.colors.tabs.contentActive};
    }

    &:after {
      background-color: ${(props) => props.theme.colors.tabs.contentActive};
    }
  }
`
